import { render, staticRenderFns } from "./FormularioPedirCambioContrasena.vue?vue&type=template&id=331ffa6d&"
import script from "./FormularioPedirCambioContrasena.vue?vue&type=script&lang=js&"
export * from "./FormularioPedirCambioContrasena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports